<div class="overlay" *ngIf="isOpen">
    <div class="dialog" #dialogElement [ngStyle]="{ 'width': isMobile ? '360px' : '600' }">

        <div class="dialog-header border-bottom">
            <h4 class="ms-3">Release Notes</h4>
        </div>

        <div class="dialog-body ms-4">
            <div *ngIf="loading">
                Loading &nbsp;<div class="waiting-gif"></div>
            </div>
            <div *ngIf="!loading">
                <h4><strong>What's New</strong></h4>
                <div class="version-block pb-3 border-bottom"
                     *ngFor="let versionModel of versionModels">
                    <div class="version-header text-muted mb-2" style="font-size: 15px;">
                        Version {{ versionModel.version }}
                    </div>
                    <div class="version-notes" [innerHTML]="versionModel.notes"></div>
                </div>
            </div>
        </div>

        <div class="dialog-footer border-top">
            <button style="width:100px" class="btn btn-outline-primary mt-2" (click)="close()">OK</button>
        </div>
    </div>
</div>
